import React from "react";

/**
 * ─── PageSection ──────────────────────────────────────────────────────────
 * Lower-hierarchy section header. Mirrors PageHeader visually but with:
 *  • title 15 px / 600 (vs 22 px on PageHeader)
 *  • eyebrow 10 px (vs 10.5 px)
 *  • no bottom divider (sections divide themselves)
 *
 * Use PageSection between Card blocks; use PageHeader once at page top.
 *
 * Props
 *   eyebrow, title, description, actions, testId
 */
export default function PageSection({ eyebrow, title, description, actions, testId }) {
  return (
    <header className="ds-pagesection" data-testid={testId}>
      <div className="ds-pagesection__body">
        {eyebrow && <div className="ds-pagesection__eyebrow">{eyebrow}</div>}
        {title   && <div className="ds-pagesection__title">{title}</div>}
        {description && <div className="ds-pagesection__desc">{description}</div>}
      </div>
      {actions && <div className="ds-pagesection__actions">{actions}</div>}
    </header>
  );
}
